import React, { useState } from "react";
import { View, Text, StyleSheet, Image, TouchableOpacity } from "react-native";
import Colors from "../constants/Colors";
import DefaultTextBold from "./text/DefaultTextBold";
import { Ionicons } from "@expo/vector-icons";

const PlaylistItem = (props) => {
  let thumbnailImg = props.imageUrl;
  if (props.imageUrl.endsWith("mp4") || props.imageUrl.endsWith("svg")) {
    thumbnailImg = props.collectionImageUrl;
  }
  return (
    <View
      style={[
        styles.container,
        { backgroundColor: props.isActive ? "#333333" : "black" },
      ]}
    >
      <View style={styles.leftContainer}>
        <Image source={{ uri: thumbnailImg }} style={styles.image} />
        <View style={styles.textContainer}>
          <DefaultTextBold style={styles.textInnerContainer}>
            {props.title}
          </DefaultTextBold>
          <DefaultTextBold style={styles.textInnerContainer}>
            {props.artist}
          </DefaultTextBold>
        </View>
      </View>
      <View style={styles.rightContainer}>
        <TouchableOpacity onPress={props.delete.bind(this, props.id)}>
          <Ionicons
            style={styles.icon}
            name="close-outline"
            size={26}
            color="white"
          />
        </TouchableOpacity>

        <TouchableOpacity
          onLongPress={props.drag}
          delayLongPress={50}
          disabled={props.isActive}
        >
          <Ionicons
            style={styles.icon}
            name="menu-outline"
            size={26}
            color="white"
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 4,
    flex: 0,
  },
  leftContainer: {
    marginVertical: 0,
    flexDirection: "row",
    alignItems: "center",
    flex: 4,
  },
  textContainer: {
    flexShrink: 1,
  },
  textInnerContainer: {
    marginVertical: 4,
  },
  rightContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginRight: 0,
    flex: 1,
  },
  icon: {
    marginHorizontal: 5,
  },
  image: {
    width: 90,
    height: 90,
    marginRight: 10,
  },
});

export default PlaylistItem;
